export const BASE_ENDPOINT = `api`;
export const SPACE_ENDPOINT = `${BASE_ENDPOINT}/space`;
export const SCRIPT_ENDPOINT = `StoryFlow/Script`;
export const ACCOUNT_ENDPOINT = `${BASE_ENDPOINT}/account`;
